import { render, staticRenderFns } from "./PortalRfxTodoList.vue?vue&type=template&id=1ddd0ac4"
import script from "./PortalRfxTodoList.vue?vue&type=script&lang=js"
export * from "./PortalRfxTodoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports